import { useEffect } from 'react';
import { MapContainer, Marker, Polyline, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';

L.Icon.Default.mergeOptions({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const meIcon = L.divIcon({
  className: '',
  html: '<div style="width:20px;height:20px;border-radius:50%;background:#22C55E;border:3px solid #0B0F14;box-shadow:0 0 0 3px rgba(34,197,94,0.4)"></div>',
  iconSize: [20, 20],
  iconAnchor: [10, 10],
});

const pickupIcon = L.divIcon({
  className: '',
  html: '<div style="width:14px;height:14px;border-radius:50%;background:#E5E9F0;border:3px solid #0B0F14"></div>',
  iconSize: [14, 14],
  iconAnchor: [7, 7],
});

const dropIcon = L.divIcon({
  className: '',
  html: '<div style="width:14px;height:14px;border-radius:3px;background:#F59E0B;border:3px solid #0B0F14"></div>',
  iconSize: [14, 14],
  iconAnchor: [7, 7],
});

interface MapViewProps {
  centre: { lat: number; lng: number };
  me?: { lat: number; lng: number } | null;
  pickup?: { lat: number; lng: number };
  drop?: { lat: number; lng: number };
  routeTo?: { lat: number; lng: number } | null;
  className?: string;
}

function ViewSync({ centre, me, pickup, drop }: MapViewProps) {
  const map = useMap();
  useEffect(() => {
    if (pickup && drop) {
      map.fitBounds(
        [
          [pickup.lat, pickup.lng],
          [drop.lat, drop.lng],
        ],
        { padding: [40, 40] },
      );
      return;
    }
    if (me) {
      map.panTo([me.lat, me.lng]);
      return;
    }
    map.setView([centre.lat, centre.lng], map.getZoom() || 13);
  }, [map, centre.lat, centre.lng, me?.lat, me?.lng, pickup?.lat, pickup?.lng, drop?.lat, drop?.lng]);
  return null;
}

export function MapView(props: MapViewProps) {
  const { centre, me, pickup, drop, routeTo, className } = props;
  return (
    <MapContainer
      center={[centre.lat, centre.lng]}
      zoom={13}
      zoomControl={false}
      className={className ?? 'h-full w-full'}
    >
      <TileLayer
        attribution='&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <ViewSync {...props} />
      {me ? <Marker position={[me.lat, me.lng]} icon={meIcon} /> : null}
      {pickup ? <Marker position={[pickup.lat, pickup.lng]} icon={pickupIcon} /> : null}
      {drop ? <Marker position={[drop.lat, drop.lng]} icon={dropIcon} /> : null}
      {me && routeTo ? (
        <Polyline
          positions={[
            [me.lat, me.lng],
            [routeTo.lat, routeTo.lng],
          ]}
          pathOptions={{ color: '#22C55E', weight: 4, opacity: 0.95 }}
        />
      ) : null}
      {pickup && drop && !me ? (
        <Polyline
          positions={[
            [pickup.lat, pickup.lng],
            [drop.lat, drop.lng],
          ]}
          pathOptions={{ color: '#E5E9F0', weight: 3, opacity: 0.7, dashArray: '6 8' }}
        />
      ) : null}
    </MapContainer>
  );
}
